import { Alert } from '@/shared/components/rebranded/Alert/Alert';
import { FieldProps, StringSchema } from '../../types';
import { Wrapper } from './styles';

type HelpTextFieldProps = FieldProps<StringSchema, string>;

export const HelpTextField = ({ schema }: HelpTextFieldProps) => {
  return (
    <Alert
      title={schema.title || 'OBS'}
      fluid
      variant={(schema.$uiOptions && schema.$uiOptions.alertType) || 'info'}
    >
      <Wrapper html={schema.description || schema.const || ''} />
    </Alert>
  );
};
